<template>
    <div class="container-fluid">
        <div class="row">
            <div class="col-xl-4 col-12 mb-3">
                <div class="card">
                    <div class="card-header" :class="{'blue-gradient': admin.habeas_data == 1}">Habeas data</div>
                    <div class="card-body">
                        <div class="form-group">
                            <input class="btn mt-3" :class="{'btn-warning': admin.habeas_data == 1, 'btn-primary': admin.habeas_data == 0 || admin.habeas_data == null}" type="button" :value="habeasStatus" @click.prevent="updateHabeas">
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-xl-4 col-12 mb-3">
                <div class="card">
                    <div class="card-header" :class="{'blue-gradient': admin.role == 1}">Rol</div>
                    <div class="card-body">
                        <div class="form-group">
                            <input class="btn mt-3" :class="{'btn-warning': admin.role == 1, 'btn-primary': admin.role == 0 || admin.role == null}" type="button" :value="roleStatus" @click.prevent="updateRole">
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: 'cities',
    created: function(){
        this.checkAuth();
    },
    data(){
        return {
            baseUrl: process.env.VUE_APP_API,
            currentCity: null,
            admin: {}
        }
    },
    computed: {
        habeasStatus(){
            return this.admin.habeas_data ? "Desactivar" : "Activar";
        },
        roleStatus(){
            return this.admin.role ? "Desactivar" : "Activar";
        }
    },
    methods: {
        checkAuth(){
            const loader = this.$loading.show();
            const requestUrl = `${this.baseUrl}/auth/me`;
            this.$http.post(requestUrl, {tal: "cosa"},
            {headers: {Authorization: `Bearer ${localStorage.getItem('session_id')}`}})
            .then(data => {
                this.admin = data.body.user;
                loader.hide();
            })
            .catch(error => {
                console.log(error);
                localStorage.clear();
                this.$router.push({name: 'home'});
            })
        },
        update(data){
            const requestUrl = `${this.baseUrl}/admin/profile`;
            const loader = this.$loading.show();
            this.$http.put(requestUrl, data,
            {headers: {Authorization: `Bearer ${localStorage.getItem('session_id')}`}})
            .then(response => {
                this.admin = response.body.data;
                loader.hide();
            })
            .catch(error => {
                loader.hide();
                console.log(error);
            })
        },
        updateHabeas(){
            const newHabeas = this.admin.habeas_data == 0 || this.admin.habeas_data == null ? 1 : 0;
            this.update({habeas_data: newHabeas});
        },
        updateRole(){
            const role = this.admin.role == 0 || this.admin.role == null ? 1 : 0;
            this.update({role});
        },
    }

}
</script>
<style lang="sass" scoped>
    @import '../../assets/scss/colors';
</style>


